import { generatePath } from "react-router-dom";
import { useMemo } from "react";
import { SystemDicPersonType } from "gql/graphql";
import { usePersonOptions } from "../../select";
import { EMPLOYEE_PROFILE_PATH } from "@/modules/profile/pages/employee-profile";

const UUID_REGEXP =
  /@[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/g;

export function usePersonMention() {
  const { options, persons, loading } = usePersonOptions();

  // Уволенного больше не предлагаем упомянуть, но его уже написанные упоминания
  // по-прежнему переводятся в имя по полному списку options.
  const mentionOptions = useMemo(() => {
    const firedIds = new Set(
      persons
        .filter(
          (person) =>
            person.personType?.code === SystemDicPersonType.Exemployee,
        )
        .map((person) => person.id),
    );

    return options.filter((option) => !firedIds.has(option.value ?? ""));
  }, [options, persons]);

  const toStringWithPersonNames = (stringWithIds: string | undefined) => {
    if (stringWithIds === undefined) {
      return undefined;
    }

    return stringWithIds.replace(UUID_REGEXP, (match) => {
      const label = options.find(
        (option) => `@${option.value}` === match,
      )?.label;

      return label ? `@${label}` : match;
    });
  };

  const toStringWithIds = (stringWithPersonNames: string) => {
    let result = stringWithPersonNames;

    for (const option of options) {
      if (option.label) {
        result = result.replace(`@${option.label}`, `@${option.value}`);
      }
    }

    return result;
  };

  const toStringWithPersonLinks = (stringWithIds: string) => {
    return stringWithIds.replace(UUID_REGEXP, (match) => {
      const id = match.slice(1);

      const label = options.find((option) => option.value === id)?.label;

      if (!label) {
        return match;
      }

      return `<a target="_blank" href="${generatePath(EMPLOYEE_PROFILE_PATH, { id })}">@${label}</a>`;
    });
  };

  return {
    mentionOptions,
    loading,
    toStringWithIds,
    toStringWithPersonNames,
    toStringWithPersonLinks,
  };
}
